import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Leaflet() {
  const [qr, setQr] = useState(null);

  const fetchQR = useCallback(() => {
    axios.get(`${API}/qr/home`).then(res => setQr(res.data.qr_base64)).catch(() => {});
  }, []);

  useEffect(() => {
    fetchQR();
  }, [fetchQR]);

  return (
    <div className="min-h-screen bg-white flex justify-center py-4 print:py-0" data-testid="leaflet-page">
      <div className="leaflet-container" style={{ width: '99mm', minHeight: '210mm', fontFamily: "'Outfit', sans-serif", background: '#FAF6F0', position: 'relative', overflow: 'hidden' }}>
        
        {/* Top accent bar */}
        <div style={{ height: '6px', background: '#E05D3A' }} />

        {/* Header with Logo */}
        <div style={{ textAlign: 'center', padding: '10px 12px 6px' }}>
          <img 
            src="/logo.jpeg" 
            alt="ANAN's Kitchen" 
            style={{ width: '70px', height: '70px', borderRadius: '50%', margin: '0 auto', display: 'block', objectFit: 'cover', border: '2px solid #2C402E' }}
          />
          <p style={{ color: '#E05D3A', fontSize: '7px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', marginTop: '4px' }}>Bristol, United Kingdom</p>
        </div>

        {/* Launch Banner */}
        <div style={{ background: '#2C402E', color: 'white', textAlign: 'center', padding: '6px 10px', margin: '0 10px', borderRadius: '8px' }}>
          <p style={{ fontSize: '10px', fontWeight: '700', margin: 0, color: '#D4AF37' }}>DELIVERIES START 7TH JUNE!</p>
        </div>

        {/* 3 Meals Section */}
        <div style={{ padding: '8px 10px 4px' }}>
          <p style={{ fontSize: '8px', fontWeight: '700', color: '#2C402E', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '5px' }}>Every Day Meal Includes</p>
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <img src="https://static.prod-images.emergentagent.com/jobs/8dcb2a80-f509-441b-b99e-0f9224a5cf02/images/c64f55b4558b7c1ca473da7f77be45a209b3fe97c8b57dd229233548b040e910.png" alt="Meal 1" style={{ width: '100%', height: '52px', objectFit: 'cover', borderRadius: '6px' }} />
              <p style={{ fontSize: '5.5px', color: '#2C402E', fontWeight: '600', margin: '3px 0 0' }}>Boiled Egg, Veg Salad & Fruit Salad</p>
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <img src="https://static.prod-images.emergentagent.com/jobs/8dcb2a80-f509-441b-b99e-0f9224a5cf02/images/09842102b46890056965059230efc183922582418eb5349a8baa377ba9ed9b73.png" alt="Meal 2" style={{ width: '100%', height: '52px', objectFit: 'cover', borderRadius: '6px' }} />
              <p style={{ fontSize: '5.5px', color: '#2C402E', fontWeight: '600', margin: '3px 0 0' }}>3 Chapathis with Curry or Fry</p>
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <img src="https://static.prod-images.emergentagent.com/jobs/8dcb2a80-f509-441b-b99e-0f9224a5cf02/images/a86f98bfb4775492c7daed68e8ae0bab3904eea144ebc0815048a0a1633dcd7d.png" alt="Meal 3" style={{ width: '100%', height: '52px', objectFit: 'cover', borderRadius: '6px' }} />
              <p style={{ fontSize: '5.5px', color: '#2C402E', fontWeight: '600', margin: '3px 0 0' }}>Biryani or Rice with a Curry</p>
            </div>
          </div>
        </div>

        {/* Weekly Menu */}
        <div style={{ padding: '4px 10px' }}>
          <p style={{ fontSize: '8px', fontWeight: '700', color: '#2C402E', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>7-Day Set Menu</p>
          <div style={{ display: 'flex', gap: '6px' }}>
            {/* Veg */}
            <div style={{ flex: 1, background: '#2C402E', borderRadius: '6px', padding: '5px 6px' }}>
              <p style={{ fontSize: '6.5px', fontWeight: '700', color: '#D4AF37', textAlign: 'center', marginBottom: '3px' }}>VEGETARIAN</p>
              {[
                ['Mon', 'Dal & Jeera Rice'],
                ['Tue', 'Mixed Veg Curry & Jeera Rice'],
                ['Wed', 'Tomato Masala & Jeera Rice'],
                ['Thu', 'Mirchi Kasalan & Jeera Rice'],
                ['Fri', 'Mushroom Curry & Jeera Rice'],
                ['Sat', 'Vegetable Biryani'],
                ['Sun', 'Paneer Biryani'],
              ].map(([day, meal]) => (
                <div key={day} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(250,246,240,0.1)', padding: '1.5px 0' }}>
                  <span style={{ fontSize: '5.5px', color: '#D4AF37', fontWeight: '600', minWidth: '20px' }}>{day}</span>
                  <span style={{ fontSize: '5.5px', color: '#FAF6F0', textAlign: 'right' }}>{meal}</span>
                </div>
              ))}
            </div>
            {/* Non-Veg */}
            <div style={{ flex: 1, background: '#E05D3A', borderRadius: '6px', padding: '5px 6px' }}>
              <p style={{ fontSize: '6.5px', fontWeight: '700', color: '#FAF6F0', textAlign: 'center', marginBottom: '3px' }}>NON-VEGETARIAN</p>
              {[
                ['Mon', 'Dal Jeera Rice & Chicken Fry'],
                ['Tue', 'Khichdi Kheema'],
                ['Wed', 'Bagara Rice & Chicken Curry'],
                ['Thu', 'Butter Chicken & Jeera Rice'],
                ['Fri', 'Bagara Rice & Lamb Curry'],
                ['Sat', 'Chicken Biryani'],
                ['Sun', 'Lamb Biryani'],
              ].map(([day, meal]) => (
                <div key={day} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.15)', padding: '1.5px 0' }}>
                  <span style={{ fontSize: '5.5px', color: '#D4AF37', fontWeight: '600', minWidth: '20px' }}>{day}</span>
                  <span style={{ fontSize: '5.5px', color: '#FAF6F0', textAlign: 'right' }}>{meal}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Prices */}
        <div style={{ display: 'flex', gap: '4px', padding: '6px 10px 4px' }}>
          <div style={{ flex: 1, background: '#2C402E', borderRadius: '6px', padding: '5px', textAlign: 'center' }}>
            <p style={{ fontSize: '6px', color: '#D4AF37', fontWeight: '600', margin: 0 }}>WEEKLY</p>
            <p style={{ fontSize: '11px', color: 'white', fontWeight: '800', margin: '1px 0' }}>£60 / £70</p>
            <p style={{ fontSize: '5px', color: '#FAF6F0', opacity: 0.7, margin: 0 }}>veg / non-veg</p>
          </div>
          <div style={{ flex: 1, background: '#E05D3A', borderRadius: '6px', padding: '5px', textAlign: 'center' }}>
            <p style={{ fontSize: '6px', color: '#FAF6F0', fontWeight: '600', margin: 0 }}>MONTHLY</p>
            <p style={{ fontSize: '11px', color: 'white', fontWeight: '800', margin: '1px 0' }}>£229 / £249</p>
            <p style={{ fontSize: '5px', color: '#FAF6F0', opacity: 0.7, margin: 0 }}>veg / non-veg</p>
          </div>
          <div style={{ flex: 1, background: '#D4AF37', borderRadius: '6px', padding: '5px', textAlign: 'center' }}>
            <p style={{ fontSize: '6px', color: '#2C402E', fontWeight: '600', margin: 0 }}>SINGLE ORDER</p>
            <p style={{ fontSize: '11px', color: '#2C402E', fontWeight: '800', margin: '1px 0' }}>£15 / £17</p>
            <p style={{ fontSize: '5px', color: '#2C402E', opacity: 0.7, margin: 0 }}>veg / non-veg</p>
          </div>
        </div>

        {/* Delivery Slots */}
        <div style={{ display: 'flex', gap: '4px', padding: '0 10px 4px' }}>
          <div style={{ flex: 1, border: '1px solid #2C402E', borderRadius: '6px', padding: '4px', textAlign: 'center' }}>
            <p style={{ fontSize: '5.5px', color: '#4A4A4A', margin: 0 }}>Delivery Slot 1</p>
            <p style={{ fontSize: '9px', color: '#2C402E', fontWeight: '700', margin: '1px 0 0' }}>12 - 3 PM</p>
          </div>
          <div style={{ flex: 1, border: '1px solid #2C402E', borderRadius: '6px', padding: '4px', textAlign: 'center' }}>
            <p style={{ fontSize: '5.5px', color: '#4A4A4A', margin: 0 }}>Delivery Slot 2</p>
            <p style={{ fontSize: '9px', color: '#2C402E', fontWeight: '700', margin: '1px 0 0' }}>5 - 10 PM</p>
          </div>
        </div>

        {/* Offers Row */}
        <div style={{ display: 'flex', gap: '4px', padding: '0 10px 4px' }}>
          {/* Refer */}
          <div style={{ flex: 1, background: '#FAF6F0', border: '1px solid #E05D3A', borderRadius: '6px', padding: '5px', textAlign: 'center' }}>
            <p style={{ fontSize: '6px', color: '#E05D3A', fontWeight: '700', textTransform: 'uppercase', margin: 0 }}>Refer a Friend</p>
            <p style={{ fontSize: '10px', color: '#2C402E', fontWeight: '800', margin: '1px 0' }}>£10 OFF</p>
            <p style={{ fontSize: '5px', color: '#4A4A4A', margin: 0 }}>for every referral</p>
          </div>
          {/* Puzzle */}
          <div style={{ flex: 1, background: '#FAF6F0', border: '1px solid #D4AF37', borderRadius: '6px', padding: '5px', textAlign: 'center' }}>
            <p style={{ fontSize: '6px', color: '#D4AF37', fontWeight: '700', textTransform: 'uppercase', margin: 0 }}>Monthly Puzzle</p>
            <p style={{ fontSize: '7px', color: '#2C402E', fontWeight: '700', margin: '1px 0' }}>Win AirPods!</p>
            <p style={{ fontSize: '5px', color: '#4A4A4A', margin: 0 }}>Next month: Apple Watch</p>
          </div>
        </div>

        {/* Allergens */}
        <div style={{ padding: '0 10px 4px' }}>
          <div style={{ background: '#fff3cd', borderRadius: '6px', padding: '4px 6px', display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
            <span style={{ fontSize: '8px' }}>&#9888;</span>
            <p style={{ fontSize: '5px', color: '#856404', margin: 0, lineHeight: 1.4 }}>
              <strong>Allergens:</strong> Our meals contain <strong>Eggs, Gluten (Wheat), Dairy, Nuts, Peanuts & Mustard</strong>. 
              Cross-contamination may occur. Contact us for details.
            </p>
          </div>
        </div>

        {/* Socials & Contact */}
        <div style={{ background: '#2C402E', padding: '6px 10px', margin: '0' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginBottom: '3px' }}>
                <a href="https://www.facebook.com/profile.php?id=61561000261625" style={{ color: '#FAF6F0', fontSize: '6px', textDecoration: 'none' }}>
                  Facebook: /ananskitchen
                </a>
                <a href="https://www.instagram.com/ananskitchenbristol/" style={{ color: '#FAF6F0', fontSize: '6px', textDecoration: 'none' }}>
                  Instagram: @ananskitchenbristol
                </a>
              </div>
              <p style={{ fontSize: '6px', color: '#D4AF37', margin: 0 }}>
                ananskitchenbristol@gmail.com
              </p>
              <p style={{ fontSize: '5px', color: '#FAF6F0', opacity: 0.6, margin: '2px 0 0' }}>
                Free Home Delivery in Bristol
              </p>
            </div>
            {qr && (
              <div style={{ textAlign: 'center' }}>
                <img src={qr} alt="QR Code" style={{ width: '45px', height: '45px', borderRadius: '4px' }} />
                <p style={{ fontSize: '4px', color: '#D4AF37', margin: '1px 0 0' }}>Scan to visit</p>
              </div>
            )}
          </div>
        </div>

      </div>

      {/* Print styles */}
      <style>{`
        @media print {
          body { margin: 0; padding: 0; }
          .leaflet-container { 
            width: 99mm !important; 
            min-height: 210mm !important;
            margin: 0 !important;
            box-shadow: none !important;
          }
          header, footer, [data-testid="social-bar"], [data-testid="footer"] { display: none !important; }
        }
        @media screen {
          .leaflet-container {
            box-shadow: 0 4px 20px rgba(0,0,0,0.15);
            border-radius: 4px;
          }
        }
      `}</style>
    </div>
  );
}
